import { useEffect } from 'react'
import CustomHead from 'components/commons/CustomHead'
import Template from 'components/cases/kaiho/Kaiho'

const kaiho: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'システム開発 AWS UIUX 要件定義 ECサイト'}
        image={'https://www.i3design.jp/OGP_logo.png'}
        url={'https://www.i3design.jp/cases/kaiho'}
        title="グローバルECサイト | 事例 | i3DESIGN アイスリーデザイン"
        description="グローバルECサイト 会宝産業株式会社様｜自動車リサイクルを通して地球規模の循環型社会を目指す会宝産業株式会社が自動車の中古部品を世界中に販売するECサイト。弊社では、要件定義からシステム開発、運用まで一貫して実施させていただきました。"
      />
      <Template />
    </>
  )
}

export default kaiho
